import { Curriculum } from "./components/Curriculum/template";
export const Title = ({ course }) => {
  return (
    <>
      {course === "mkt" ? (
        <>
          서비스 제작부터 데이터 분석까지, <br />
          실무를 그대로 압축한 커리큘럼
        </>
      ) : (
        <>
          주 3일 100% 온라인으로
          <br />
          직장과 병행하는 커리큘럼
        </>
      )}
    </>
  );
};

export const pmCurriculums: Curriculum[] = [
  {
    title: "사전 과제",
    period: "0주차",
    goals: [
      "‘코딩이 처음이어도 쉽게 배우는 웹개발 A to Z' 강의로 웹의 기본부터 배포까지 학습\n",
      "자율적 사전 스터디를 통해 PM 필독서를 읽으며, 직무에 대해 이해도 높이기\n",
    ],
    details: [
      {
        week: "0주차",
        courses: [
          {
            title: "",
            lectures: [
              "웹의 동작 원리 이해",
              "눈에 보이는 페이지 만들기",
              "웹스크래핑(크롤링), 데이터베이스 다루기",
              "PM 필독서 사전 스터디",
            ],
          },
        ],
      },
    ],
  },
  {
    title: "기초 역량 및 심화 교육",
    period: "1~2주차",
    goals: [
      "PM의 마인드를 세팅하고 업무 용어 및 툴 학습",
      "PM의 주요한 역할인 '문제 발견과 솔루션 도출 과정', 'PM의 의사 결정 방법론' 이해",
      "PM의 Data framework 이해 - AARRR",
      "역기획 & 개선 과제를 통한 프로덕트 이해 및 서비스 기획 프로세스 파악 경험",
    ],
    details: [
      {
        week: "1주차",
        courses: [
          {
            title: "",
            lectures: [
              "PM 직무와 개념의 차이",
              "문제 발견과 솔루션 도출 과정 이해하기",
              "역기획을 통해 서비스 기획 프로세스, 사고 흐름 파악하기",
              "Figma와 친해지기",
              "[과제] 팀 프로젝트 - 비즈니스 역기획",
            ],
          },
        ],
      },
      {
        week: "2주차",
        courses: [
          {
            title: "",
            lectures: [
              "프로젝트 관리 방법론 학습 - 린, 애자일 등",
              "Product Market fit 찾기 - 초기 제품에 대한 이해",
              "그로스 해킹 - 우리 고객을 최종 목표까지 전환 시키기",
              "OKR에 대해 이해하고, 비즈니스 이해도 높이기",
              "[과제] 개인 프로젝트 - 피그마로 클론 디자인 하기",
              "[과제] 팀 프로젝트 - 비지니스 역기획",
            ],
          },
        ],
      },
    ],
  },
  {
    title: "웹개발 미니 프로젝트",
    period: "3~4주차",
    goals: [
      "개발에 대한 이해도를 높여 개발자와 일하는 방식 이해하기",
      "UX/UI에 대해 이해하고, 초기 제품의 MVP 기획과 디자인을 독자적으로 할 수 있는 PM 되기",
      "PM의 Data framework 이해",
      "역기획 & 퍼널 개선 과제를 통한 프로덕트 이해 및 서비스 기획 프로세스 파악 경험",
      "Webflow 노코드툴 강의 수강을 통해 노코드툴을 이해하고 실전 프로젝트의 MVP 개발 능력 함양",
    ],
    details: [
      {
        week: "3주차",
        courses: [
          {
            title: "",
            lectures: [
              "PM을 위한 UX 디자인 : UX의 핵심과 리서치 방법, 실전 UX 프로세스",
              "PM을 위한 UI 전략 및 접근법",
              "비개발자가 이해하는 개발/디자인 개념",
              "[과제] 팀 프로젝트 - 실존 서비스 퍼널 개선안 제안",
              "[과제] 개인 프로젝트 - 웹개발 미니 실습",
            ],
          },
        ],
      },
      {
        week: "4주차",
        courses: [
          {
            title: "",
            lectures: [
              "고객의 프로덕트 여정 - AARRR (Aquisition, Activation, Retention, Referral, Revenue)",
              "노코드툴 Webflow 학습",
              "[과제] 팀 프로젝트 - 실존 서비스 퍼널 개선안 제안",
            ],
          },
        ],
      },
    ],
  },
  {
    title: "PM 실전 프로젝트",
    period: "5~12주차",
    goals: [
      "웹 서비스 기획, 개발, 런칭, 운영까지의 전 과정을 경험",
      "창업에 가까운 실전 경험을 팀 프로젝트로 수행하여, 실무에서 요구되는 PM 역량 강화",
      "가상의 서비스가 아닌 실제 우리 서비스의 데이터를 수집하고, 데이터 기반으로 프로덕트 개선 작업을 진행",
    ],
    details: [
      {
        week: "5~7주차 - 기획",
        courses: [
          {
            title: "",
            lectures: [
              "기획 단계에서의 효율적인 문서 작성법 - Wireframe, User journey map, 1Pager",
              "기획 단계에서의 효율적인 문서 작성법 - PRD, 정보 구조도, WBS",
              "유관 부서와 일하는 법과 프로덕트 사이클 이해",
              "서비스 MVP 제작 및 개발을 위한 노코드툴 Webflow 학습",
              "[과제] 실전 프로젝트 팀 빌딩 및 우리 서비스의 MVP 기획",
              "[과제] 우리 서비스의 1Pager, Wireframe 작성하기",
              "[과제] 노코드 개발 명세 작성",
            ],
          },
        ],
      },
      {
        week: "8~9주차 - 서비스 제작 (개발)",
        courses: [
          {
            title: "",
            lectures: [
              "서비스 MVP 제작 및 개발을 위한 노코드툴 Webflow 학습",
              "GA4, Amplitude 등을 통한 데이터 수집/분석/해석",
              "MVP 서비스 제작에 대한 Case study",
              "[과제] 우리 서비스의 MVP 구현 및 실제 서비스 제작하기",
            ],
          },
        ],
      },
      {
        week: "10~12주차 - 서비스 개선 및 회고",
        courses: [
          {
            title: "",
            lectures: [
              "고객 인터뷰로 유의미한 개선점 도출하기",
              "마케팅을 통한 모객 및 서비스 운영 경험",
              "AB Test 목적과 케이스 이해하기",
              "[과제] 수집된 로그 데이터 분석 및 고객 보이스 수집을 통한 개선 스프린트(전환, AARRR, UX, UX Writing 등)",
              "[과제] 데이터 그룹핑 (로지컬 씽킹) 활용 및 프로젝트 회고 (KPT)",
            ],
          },
        ],
      },
    ],
  },
  {
    title: "취업 준비",
    period: "13주차",
    goals: [
      "지금까지의 경험을 액션, 데이터에 기반해 설명하기",
      "부트캠프 양산형이 아닌, 나의 강점이 잘 드러나는 특별한 포트폴리오 만들기",
    ],
    details: [
      {
        week: "13주차 - 기획",
        courses: [
          {
            title: "",
            lectures: [
              "면접관의 시선을 끄는 이력서/포트폴리오 작성",
              "면접관의 시선으로 면접 준비하기",
              "[과제] 이력서/포트폴리오 완성",
              "[과제] 내 이력서 기반의 면접 예상 질문 리스트, 답변 준비",
            ],
          },
        ],
      },
    ],
  },
];

export const mktCurriculums: Curriculum[] = [
  {
    title: "사전 스터디",
    period: "",
    goals: [
      "기존 마케팅 기법에 대한 이해도를 높이고, 최신 트렌드 학습 및 적용해보기",
      "'엑셀보다 쉬운 SQL' 수강하며 데이터 저장 형태부터 추출까지 이해하기",
    ],
    details: [],
  },
  {
    title: "필수 과제",
    period: "0주차",
    goals: ["HTML / CSS 기본 이론으로 웹의 구조 익히기"],
    details: [
      {
        week: "",
        courses: [
          {
            title: "",
            lectures: ["HTML / CSS 기본 구조 이론을 담은 강의 수강하기"],
          },
        ],
      },
    ],
  },
  {
    title: "그로스 마케팅 이해",
    period: "1~4주차",
    goals: [
      "데이터에 기반하여 비즈니스와 프로덕트별 고객 특성을 이해하기 ",
      "콘텐츠 제작부터 유통, 고객 유입, 데이터 드리븐 의사결정까지 핵심 이론 학습하기",
      "실제 서비스 환경에서의 실습을 통한 기본 실력 향상",
    ],
    details: [
      {
        week: "오리엔테이션",
        courses: [
          {
            title: "",
            lectures: [
              "소통 채널, 상세 커리큘럼 안내 등을 진행하며 운영 PM과 만나는 첫 자리",
            ],
          },
        ],
      },
      {
        week: "1주차",
        courses: [
          {
            title: "",
            lectures: [
              "기본 마케팅 지표 및 시장/고객 조사 이론 배우기",
              "유저 리서치 적용해서 고객 페르소나 이해하기",
              "Figma를 활용해 타겟 고객을 설득하는 시각 콘텐츠 만들기",
              "타겟 맞춤형 제품 상세페이지 기획 및 제작하기",
            ],
          },
        ],
      },
      {
        week: "2주차",
        courses: [
          {
            title: "",
            lectures: [
              "SA, DA 각 지면의 차이 및 고성과 전략 이해하기",
              "계정 생성해서 SA, DA 광고 세팅하기",
              "UTM 및 캠페인명 택소노미 설계하기",
              "오가닉 유저를 늘리기 위한 SEO 학습 및 실습하기",
            ],
          },
        ],
      },
      {
        week: "3주차",
        courses: [
          {
            title: "",
            lectures: [
              "CRM 마케팅 성과 분석에 필요한 주요 지표 배우기",
              "GA4 실습하기",
              "이벤트 데이터 분류 체계 기획해서 GTM 실습하기",
              "Amplitude 기본 차트 활용해 대시보드화하기",
            ],
          },
        ],
      },
      {
        week: "4주차",
        courses: [
          {
            title: "",
            lectures: [
              "주요 광고 지표의 중요성 및 산출 기준 이해하기",
              "코호트, 매출, 회원가입 등 다양한 대시보드 유형 학습하고 제작하기",
              "Google Data Studio 활용해서 실시간 대시보드 제작하기",
            ],
          },
        ],
      },
    ],
  },
  {
    title: "실제 웹서비스 기획",
    period: "5~6주차",
    goals: [
      "시장 및 고객조사를 기반으로 웹서비스 기획하기",
      "노코드 툴을 활용해 MVP 서비스 직접 만들기",
    ],
    details: [
      {
        week: "5주차 - 기획",
        courses: [
          {
            title: "",
            lectures: [
              "관심 산업군 시장조사 및 타겟 시장 선정",
              "유저 리서치 및 메인 페르소나 설정",
              "타겟 고객의 문제를 해결해줄 수 있는 웹사이트 제품 기획",
              "Soft, Zapier 학습을 통한 노코드 웹사이트 구축 방법 학습 -1",
            ],
          },
        ],
      },
      {
        week: "6주차 - 개발",
        courses: [
          {
            title: "",
            lectures: [
              "Soft, Zapier 학습을 통한 노코드 웹사이트 구축 방법 학습 -2",
              "노코드툴 Webflow, Zapier 등을 통한 웹사이트 기능 개발",
              "GA< GTM 등 웹사이트 방문 데이터 수집 설계",
            ],
          },
        ],
      },
    ],
  },
  {
    title: "마케팅 실전 프로젝트",
    period: "7~11주차",
    goals: [
      "SA, DA 등 Paid, Non-paid 마케팅 전략을 기획하고 실제로 집행하기",
      "직접 수집한 실제 고객 데이터에 기반해 마케팅 전략 집행하며 지표 개선 경험 쌓기",
    ],
    details: [
      {
        week: "7주차 - 마케팅 전략 기획",
        courses: [
          {
            title: "",
            lectures: [
              "시장 및 고객 특성을 고려한 웹사이트 마케팅 전략 기획하기",
              "Figma를 활용해 웹사이트에 들어갈 콘텐츠 제작 및 카피 작성",
            ],
          },
        ],
      },
      {
        week: "8주차 - 마케팅 집행",
        courses: [
          {
            title: "",
            lectures: [
              "택소노미 기획 후 웹사이트 SEO 전략 수립 및 적용",
              "DA, SA 마케팅 전략 기획 및 소재 제작",
            ],
          },
        ],
      },
      {
        week: "9주차 - 대시보드 제작",
        courses: [
          {
            title: "",
            lectures: [
              "DA, SA 마케팅 집행 및 지표 추적",
              "주요 지표 포함한 실시간 마케팅 대시보드 제작",
            ],
          },
        ],
      },
      {
        week: "10주차 - CRM 마케팅",
        courses: [
          {
            title: "",
            lectures: [
              "대시보드 지표 및 고객 보이스 분석 통해 웹사이트 내 고객 특성 및 행동 이해하기",
              "확보된 고객 대상 CRM 마케팅 집행해서 유효 액션 이끌어내기",
            ],
          },
        ],
      },
      {
        week: "11주차 - 지표 개선",
        courses: [
          {
            title: "",
            lectures: [
              "수집된 데이터 기반으로 그간의 마케팅 가설 및 전략 평가",
              "전략 강화해서 지금보다 개선된 마케팅 지표 달성해보기",
            ],
          },
        ],
      },
    ],
  },
  {
    title: "포트폴리오 완성",
    period: "12주차",
    goals: [
      "지금까지의 경험을 액션과 데이터로 설명하기",
      "부트캠프 양산형이 아닌, 나의 강점이 잘 드러나는 특별한 포트폴리오 만들기",
    ],
    details: [
      {
        week: "12주차",
        courses: [
          {
            title: "",
            lectures: [
              "SW캠프에서의 프로젝트 경험을 강점, 데이터 위주의 결과로 요약하기",
              "마케터 채용 담당자의 피드백을 통해 포트폴리오 제작 및 개선",
            ],
          },
        ],
      },
    ],
  },
  {
    title: "취업 지원",
    period: "",
    goals: [
      "서류 & 면접 준비부터 지원 과정까지, 끝까지 책임지는 취업 지원 시스템으로 도와드립니다. 새로운 커리어를 시작하실 수 있도록 마지막까지 함께 하겠습니다.",
    ],
    details: [],
  },
];

export const curriculumABTUpdateList = [
  <>
    커리큘럼 업데이트<span></span>
  </>,
  "노코드툴(Webflow) 전담 멘토 도입으로\n실전 프로젝트 퀄리티 향상",
  "2023.06.28",
];
